document.addEventListener('alpine:init', () => {
  Alpine.data('QuickProductForm', () => ({
    product: null,
    variant_id: null,
    selected_variant: null,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      this.variant_id = this.$el.querySelector('input[name="id"]').value;
    },
    InitWatchers() {
      this.$watch('variant_id', () => {
        this.selected_variant = this.product.variants.find(variant => variant.id == this.variant_id); 
      });
    },
    u_FormatMoney(cents) {
      return themeVendor.themeCurrency.formatMoney(cents);
    }
  }));
  
  Alpine.data('QuickAddtoCart', () => ({
    async e_AddtoCart(variant_id) {
      const formData = {
        'items': [{
          'id': variant_id,
          'quantity': 1
        }]
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log('Item added to cart:', data);
        // Optionally, you can update the cart UI here
      } 
      catch (error) {
        console.error('Error adding item to cart:', error);
      }
    }
  }));
});